<template>
  <ImageListComponent :img="enrolleeType == 1 ? participantImgUrl : caregiverImgUrl">
      <h2 class="text-xl">{{ $t('welcome2.content.header') }}</h2>
      <ul class="sm:mt-auto">
        <li class="flex items-center my-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mr-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
          <span>{{ $t(`welcome2.content.list1.enrolleeType${enrolleeType}`, { firstName: participantGivenCare?.firstName}) }}</span>
        </li>
        <li class="flex items-center my-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mr-5" viewBox="0 0 26 26" fill="none" stroke="currentColor">
            <path
              d="M8 6.75V1.75M18 6.75V1.75M6.75 11.75H19.25M4.25 24.25H21.75C23.1307 24.25 24.25 23.1307 24.25 21.75V6.75C24.25 5.36929 23.1307 4.25 21.75 4.25H4.25C2.86929 4.25 1.75 5.36929 1.75 6.75V21.75C1.75 23.1307 2.86929 24.25 4.25 24.25Z"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>{{ $t(`welcome2.content.list2.enrolleeType${enrolleeType}`) }}</span>
        </li>
        <li class="flex items-center my-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mr-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{{ $t(`welcome2.content.list3.enrolleeType${enrolleeType}`, { firstName: participantGivenCare?.firstName}) }}</span>
        </li>
      </ul>
  </ImageListComponent>
</template>

<script>
import ImageListComponent from 'Views/EnrollmentPresentation/TemplateInstances/ImageListComponent.vue';

export default {
  props: ['enrolleeType', 'participantGivenCare'],
  components: {ImageListComponent},
  data() {
    return {
      caregiverImgUrl: new URL('@/assets/role-caregiver.jpg', import.meta.url).href,
      participantImgUrl: new URL('@/assets/role-participant.jpg', import.meta.url).href
    }
  },
};
</script>

<style></style>
